import { useOneoffPageview } from '@ids/hooks';
import { TRACKING_IDS_PAGE_LABELS } from '@ids/appshell';

// istanbul ignore next
export const useOverstepTracking = () => useOneoffPageview(TRACKING_IDS_PAGE_LABELS.OVERSTEP);
